import React, { useState, useEffect } from 'react';
import { Container, Card, Table, Button, Row, Col } from 'react-bootstrap';
import Select from 'react-select';
import { toast } from 'react-toastify';
import { FaTrash } from 'react-icons/fa';
import moment from 'moment';
import Header from '~/Components/Header/Header';
import Loading from '~/Components/Loading';
import ModalConfirmacao from '~/Components/ModalConfirmacao';
import * as api from '~/Services/Service';
import { customStyles } from '~/Styles/reactSelectStyles';

const TIPOS_DOCUMENTO = [
  { value: 1, label: '01-Boleto / Fatura' },
  { value: 2, label: '02-Contrato' },
  { value: 3, label: '03-NF Outros (DANFE, Transporte e etc)' },
  { value: 6, label: '06-Recibo' },
  { value: 7, label: '07-NFS/Produtor Rural' },
  { value: 8, label: '08-Tributos' },
  { value: 9, label: '09-RPA' },
  { value: 10, label: '10-NFS MEI' },
  { value: 99, label: '99-Outros' },
];

const DespesaTipoPagamento = () => {
  const [vinculos, setVinculos] = useState([]);
  const [loading, setLoading] = useState(false);
  const [contas, setContas] = useState([]);
  const [contaSelecionada, setContaSelecionada] = useState(null);
  const [tipoSelecionado, setTipoSelecionado] = useState(null);
  const [confirmacao, setConfirmacao] = useState({ show: false, item: null });

  useEffect(() => {
    carregarVinculos();
    carregarContas();
  }, []);

  const carregarVinculos = async () => {
    setLoading(true);
    try {
      const resp = await api.listarDespesaTipoPagamento();
      setVinculos(resp || []);
    } catch (err) {
      toast.error((err && err.message) ? err.message : 'Erro ao carregar vínculos.');
    } finally {
      setLoading(false);
    }
  };

  const carregarContas = async () => {
    try {
      const resp = await api.listarContasGE(20, { tipo: '3' });
      const opcoes = (resp || []).map((item) => ({
        value: item.codigo_conta,
        label: item.codigo_conta + ' - ' + (item.apelido || ''),
      }));
      setContas(opcoes);
    } catch (err) {
      toast.error('Erro ao carregar contas de despesa.');
    }
  };

  const handleIncluir = async () => {
    if (!contaSelecionada) {
      toast.warn('Informe a despesa.');
      return;
    }
    if (!tipoSelecionado) {
      toast.warn('Informe o tipo de documento.');
      return;
    }
    try {
      await api.criarDespesaTipoPagamento({
        conta: contaSelecionada.value,
        tipo: tipoSelecionado.value,
      });
      toast.success('Vínculo incluído com sucesso.');
      setContaSelecionada(null);
      setTipoSelecionado(null);
      carregarVinculos();
    } catch (err) {
      toast.error((err && err.message) ? err.message : 'Erro ao incluir vínculo.');
    }
  };

  const handleExcluir = (item) => {
    setConfirmacao({ show: true, item: item });
  };

  const handleConfirmarExclusao = async (confirmado) => {
    if (!confirmado) {
      setConfirmacao({ show: false, item: null });
      return;
    }
    const item = confirmacao.item;
    setConfirmacao({ show: false, item: null });
    try {
      await api.excluirDespesaTipoPagamento({ cod: item.cod });
      toast.success('Vínculo excluído com sucesso.');
      carregarVinculos();
    } catch (err) {
      toast.error((err && err.message) ? err.message : 'Erro ao excluir vínculo.');
    }
  };

  const itemExclusao = confirmacao.item;

  if (loading) return <Loading />;

  return (
    <Container fluid className="px-3 py-3">
      <Header title="Vínculo de Despesa com Tipo de Pagamento" />

      <Card className="shadow-sm mb-3">
        <Card.Header
          className="py-2"
          style={{ backgroundColor: '#0747a6', color: '#fff' }}
        >
          <strong>Novo Vínculo</strong>
        </Card.Header>
        <Card.Body className="py-3">
          <Row className="align-items-end">
            <Col md={4}>
              <label htmlFor="select-despesa" style={{ fontWeight: 600 }}>
                Despesa
              </label>
              <Select
                inputId="select-despesa"
                options={contas}
                value={contaSelecionada}
                onChange={(opt) => { setContaSelecionada(opt); }}
                placeholder="Selecione a despesa..."
                isSearchable
                isClearable
                styles={customStyles}
              />
            </Col>
            <Col md={4}>
              <label htmlFor="select-tipo" style={{ fontWeight: 600 }}>
                Tipo Documento
              </label>
              <Select
                inputId="select-tipo"
                options={TIPOS_DOCUMENTO}
                value={tipoSelecionado}
                onChange={(opt) => { setTipoSelecionado(opt); }}
                placeholder="Selecione o tipo..."
                isSearchable
                isClearable
                styles={customStyles}
              />
            </Col>
            <Col md={2} className="mt-2 mt-md-0">
              <Button variant="primary" onClick={handleIncluir} block>
                Incluir
              </Button>
            </Col>
          </Row>
        </Card.Body>
      </Card>

      <Card className="shadow-sm">
        <Card.Header
          className="py-2"
          style={{ backgroundColor: '#0747a6', color: '#fff' }}
        >
          <strong>
            Vínculos Cadastrados
            <span className="ml-2" style={{ fontSize: '0.85rem', opacity: 0.8 }}>
              ({vinculos.length} {vinculos.length === 1 ? 'registro' : 'registros'})
            </span>
          </strong>
        </Card.Header>
        <Card.Body className="p-0">
          <Table striped bordered hover size="sm" className="mb-0">
            <thead>
              <tr>
                <th>Conta</th>
                <th>Tipo</th>
                <th style={{ width: '150px' }}>Data Inclusão</th>
                <th>Usuário</th>
                <th style={{ width: '70px', textAlign: 'center' }}>Ações</th>
              </tr>
            </thead>
            <tbody>
              {vinculos.length === 0 ? (
                <tr>
                  <td colSpan="5" className="text-center text-muted py-3">
                    Nenhum vínculo cadastrado.
                  </td>
                </tr>
              ) : (
                vinculos.map((item) => (
                  <tr key={item.cod}>
                    <td>{item.conta}</td>
                    <td>{item.nome_tipo}</td>
                    <td>
                      {item.data_inclusao
                        ? moment(item.data_inclusao).format('DD/MM/YYYY HH:mm')
                        : ''}
                    </td>
                    <td>{item.nome_usuario}</td>
                    <td className="text-center">
                      <Button
                        size="sm"
                        variant="outline-danger"
                        title="Excluir"
                        onClick={() => { handleExcluir(item); }}
                      >
                        <FaTrash />
                      </Button>
                    </td>
                  </tr>
                ))
              )}
            </tbody>
          </Table>
        </Card.Body>
      </Card>

      <ModalConfirmacao
        show={confirmacao.show}
        title="Confirmar Exclusão"
        message={
          itemExclusao
            ? 'Confirma exclusão do vínculo da conta "' + (itemExclusao.conta || '') + '"?'
            : 'Confirma exclusão?'
        }
        onClose={handleConfirmarExclusao}
      />
    </Container>
  );
};

export default DespesaTipoPagamento;
